import { marketpricesApi } from "./marketpricesApi"
import { IFormType, XlsFormResult } from "../../interfaces/xlsForm"
import { FormField, HeadersSheet, XlsFormData } from "../../interfaces/mappingInterfaces"
import { blobToDownload } from "../../utils/helpers"

export const xlsFormSchemasApi = marketpricesApi.injectEndpoints({
  endpoints: builder => ({
    saveXlsForm: builder.mutation<XlsFormResult, XlsFormData>({
      query: body => {
        const {
          name,
          baseXlsFormSchemaId,
          adm0code,
          file,
          questionLabelPosition,
          choiceLabelPosition,
          xlsFormSubCategoryId,
        } = body
        const bodyFormData = new FormData()
        bodyFormData.append("name", name)
        bodyFormData.append("baseXlsFormSchemaId", baseXlsFormSchemaId?.toString() as string)
        bodyFormData.append("adm0code", adm0code.toString())
        bodyFormData.append("file", file)
        bodyFormData.append("questionLabelPosition", questionLabelPosition.toString())
        bodyFormData.append("choiceLabelPosition", choiceLabelPosition.toString())
        xlsFormSubCategoryId && bodyFormData.append("xlsFormSubCategoryId", xlsFormSubCategoryId.toString())

        return {
          url: "XlsFormSchemas/SaveForm",
          method: "POST",
          body: bodyFormData,
          formData: true,
        }
      },
      invalidatesTags: ["BaseXlsForm", "XlsForm", "BaseSchemas"],
    }),

    getXlsFormFieldsWithGroups: builder.query<FormField[], { xlsFormId: number }>({
      query: ({ xlsFormId }) => ({
        url: `XlsFormSchemas/FormFields`,
        method: "GET",
        params: { xlsFormId },
      }),
      transformResponse: (response: FormField[]): FormField[] =>
        response?.map(item => ({
          ...item,
          groupName: item.groupName || "Other",
        })),
      providesTags: ["XlsFormFieldsWithGroups"],
    }),

    uploadXlsFormFile: builder.mutation<{ surveyHeaders: HeadersSheet[]; choicesHeaders: HeadersSheet[] }, FormData>({
      query: body => ({
        url: "XlsFormSchemas/FileHeaders",
        method: "POST",
        body,
      }),
    }),

    getAllTypes: builder.query<IFormType[], number | undefined>({
      query: (id?: number) => ({
        url: `XlsFormSchemas/GetFormFieldTypes`,
        params: { xlsFormId: id },
      }),
    }),

    downloadXlsFormSchemasById: builder.mutation<void, { fileId: number; sourceName?: string; fileName?: string }>({
      query: ({ fileId, sourceName, fileName }) => ({
        url: `XlsFormSchemas/DownloadForm`,
        params: { id: fileId },
        method: "GET",
        responseHandler: async (response: Response) => {
          response.ok && blobToDownload(response, `${sourceName?.split(".xlsx_")[0] ?? fileName}.xlsx`)
        },
      }),
    }),
  }),
})

export const {
  useSaveXlsFormMutation,
  useLazyGetXlsFormFieldsWithGroupsQuery,
  useUploadXlsFormFileMutation,
  useLazyGetAllTypesQuery,
  useDownloadXlsFormSchemasByIdMutation,
} = xlsFormSchemasApi
